import { createStore } from '@helpers/utils';

export const initialState = {
    selectedParahub: false,
    exportListParahub: [],
    files: [],
    type: '',
};

export const useStateParahub = createStore(initialState);
